import React, { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';

import CheckoutPageHeader from '../components/checkout/CheckoutPageHeader';
import { KNOW_YOUR_CHICKEN_URL } from '../config/footerLinks';
import { paths } from '../config/paths';
import { useV2Common } from '../state/CommonProvider';

const KYF_ORIGIN = 'https://knowyourfarmer.countrychickenco.in';
/** Tall enough for typical trace page; parent scrolls with hidden scrollbar. */
const KYF_IFRAME_FALLBACK_HEIGHT = 3200;

export default function KnowYourChicken() {
  const { isDesktop } = useV2Common();
  const [loading, setLoading] = useState(true);
  const [iframeHeight, setIframeHeight] = useState(KYF_IFRAME_FALLBACK_HEIGHT);

  useEffect(() => {
    const onMessage = (event) => {
      if (event.origin !== KYF_ORIGIN) return;
      const raw = event.data?.iframeHeight ?? event.data?.height ?? event.data?.scrollHeight;
      const h = Number(raw);
      if (Number.isFinite(h) && h > 200) {
        setIframeHeight(Math.min(Math.ceil(h) + 24, 12000));
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        px: { xs: 1, sm: 2 },
        pt: { xs: 1, sm: 2 },
        pb: 2,
        boxSizing: 'border-box',
        maxWidth: isDesktop ? 1280 : '100%',
        mx: 'auto',
        width: '100%',
        height: { xs: 'calc(100dvh - 56px)', sm: 'calc(100dvh - 64px)' },
        minHeight: 0,
      }}
    >
      <CheckoutPageHeader backTo={paths.home} title="Know your chicken" />
      <Box
        className="know-your-chicken-scroll"
        sx={{
          position: 'relative',
          flex: 1,
          minHeight: 0,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        {loading ? (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'background.paper',
              zIndex: 1,
              pointerEvents: 'none',
            }}
          >
            <CircularProgress />
          </Box>
        ) : null}
        <Box
          component="iframe"
          className="know-your-chicken-iframe"
          title="Know your chicken — Country Chicken Co"
          src={KNOW_YOUR_CHICKEN_URL}
          onLoad={() => setLoading(false)}
          allow="geolocation; camera; microphone"
          sx={{
            display: 'block',
            width: '100%',
            height: iframeHeight,
            minHeight: 'calc(100dvh - 200px)',
            border: 0,
          }}
        />
      </Box>
    </Box>
  );
}
